<script setup lang="ts">
import MButton from "../MButton";
import MLabeledText from "../MLabeledText";

defineProps({
  center: Boolean,
  left: Boolean,
  horizontal: Boolean,

  items: {
    type: Array,
    default: () => [],
  },
});
</script>
<template>
  <div class="m-form-actions">
    <slot />

    <m-labeled-text :class="{ center, left, horizontal }">
      <slot name="actions">
        <m-button
          v-for="(item, i) in items.filter(Boolean)"
          :key="i"
          :to="item.to"
          ghost
          v-bind="item"
        />
      </slot>
    </m-labeled-text>
  </div>
</template>

<style lang="scss">
.m-form-actions {
  margin-top: 0 !important;
  .label {
    padding: 0 !important;
  }

  .text {
    align-items: flex-end;
    justify-content: flex-end;
  }

  & > .center {
    align-items: center;
  }

  & > .left {
    align-items: flex-start;
  }

  & > .horizontal > .text {
    flex-direction: row;
    gap: 0.5em;

    .medicus-button-container {
      min-width: auto;
    }
  }

  .ghost button {
    padding: 1px;
    &:focus {
      padding: 0;
    }
  }
}
</style>
